import { render, staticRenderFns } from "./#template.vue?vue&type=template&id=581d46ac&scoped=true&"
import script from "./#template.vue?vue&type=script&lang=js&"
export * from "./#template.vue?vue&type=script&lang=js&"
import style0 from "./#template.vue?vue&type=style&index=0&id=581d46ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d46ac",
  null
  
)

export default component.exports